<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/bM6oCv/tc-custom/9780226319117.jpg?1722576312384" alt="This image is the cover for the book Man Is by Nature a Political Animal"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Man Is by Nature a Political Animal
      </h1>
      <p class="bookDescription body article font2">
        <p>In <i>Man Is by Nature a Political Animal,</i> Peter K. Hatemi and Rose McDermott bring together a diverse group of contributors to examine the ways in which evolutionary theory and biological research are increasingly informing analyses of political behavior. Focusing on the theoretical, methodological, and empirical frameworks of a variety of biological approaches to political attitudes and preferences, the authors consider a wide range of topics, including the comparative basis of political behavior, the utility of formal modeling informed by evolutionary theory, the genetic bases of attitudes and behaviors, psychophysiological methods and research, and the wealth of insight generated by recent research on the human brain. Through this approach, the book reveals the biological bases of many previously unexplained variances within the extant models of political behavior. The diversity of methods discussed and variety of issues examined here will make this book of great interest to students and scholars seeking a comprehensive overview of this emerging approach to the study of politics and behavior.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter K. Hatemi, Rose McDermott
      </h2>
      
      <p class="authorDescription body article"><B>Peter K. Hatemi</B> associate professor of political science, microbiology, and biochemistry at Pennsylvania State University and a research fellow at the United States Studies Centre at the University of Sydney.<B><br></B>&#160;<B>Rose McDermott</B> is professor of political science at Brown University. She is the author of numerous books, including <I>Presidential Leadership,</I><I>Illness,</I><I>and Decision Making.</I><B><br></B></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?48986c59